import React from "react";
import "./Recommended.css";
import VideoCard from "./VideoCard";

function Recommended() {
  return (
    <div className="recommended">
      <div className="Recommended__videos">
        <VideoCard
          image="https://i.ytimg.com/vi/vqyIYTVFNck/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAT0MueYJBahmiM9FMn88MGWKOlGA"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              FARAAR|Latest Punjabi Song
            </a>
          }
          timestamp="4 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwnh5kAOkyTTcyFahoJLRRBSSdqYuZ-jDRt5MF2uqAA=s68-c-k-c0x00ffffff-no-rj"
          views="5M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCsaXTlOmt0o9aGeC_n_r8VQ">
              RUN UP RECORDS
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/BNnVy1pbF5w/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDHwNRoV85KGc-m1Yi20UFa1wVSTg"
          title={
            <a href="https://www.youtube.com/c/TechnicalGuruji">
              Tech Talks #1466 - BGMI 18 June Official, CoWIN Hacked?, Realme
              Laptop launch, Mi 11 Lite India, M32
            </a>
          }
          timestamp="1 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngAg8C9ez6SdBMdgEA-Aud61obXOuY1zsUPkL8Z0w=s176-c-k-c0x00ffffff-no-rj-mo"
          views="8M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCOhHO2ICt0ti9KAh-QHvttQ">
              TECHNICAL GURUJI
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/MLdXYEWTC1k/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLBKX7XaIqD2SFx5RL8Tu5d7M3QAaQ"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              Bahut Pighle Hain | Zakir khan | Stand-Up Comedy | Sukha poori 6
            </a>
          }
          timestamp="2 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwnjrRv8PYYcFcNXq2mB3ufVNSOF5N5Z2FV1ljxLhqA=s176-c-k-c0x00ffffff-no-rj-mo"
          views="1.4M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCkS7Vxu4PjM99w0Is6idjcg">
              ZAKIR KHAN
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/sZJd4epkDu4/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLDuPZmAXGoRijmfPPedlSYb1Gs59A"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              POCO M3 PRO 5G UNBOXING
            </a>
          }
          timestamp="7 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngJZm17vNotc0ojgs5rPQ7MC0eI7a2WsOtjw4SzLA=s68-c-k-c0x00ffffff-no-rj"
          views="5.8M Views"
          channel={
            <a href="https://www.youtube.com/c/TechBurner">TECH BURNER</a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/wGKb3oUo8go/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLDrOHgqSLiVBb9tFpSaTob6r2QRcA"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              WHY iphone's features always "LATE
            </a>
          }
          timestamp="9 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngW9TQgw7E7NqS3Qzd3Up3tjUzkpvMXPWAhYf3LaQ=s68-c-k-c0x00ffffff-no-rj"
          views="2.4M Views"
          channel={
            <a href="https://www.youtube.com/c/mkbhd">MARQUES BROWNLEE</a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/vqyIYTVFNck/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAT0MueYJBahmiM9FMn88MGWKOlGA"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              FARAAR|Latest Punjabi Song
            </a>
          }
          timestamp="4 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwnh5kAOkyTTcyFahoJLRRBSSdqYuZ-jDRt5MF2uqAA=s68-c-k-c0x00ffffff-no-rj"
          views="5M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCsaXTlOmt0o9aGeC_n_r8VQ">
              RUN UP RECORDS
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/BNnVy1pbF5w/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDHwNRoV85KGc-m1Yi20UFa1wVSTg"
          title={
            <a href="https://www.youtube.com/c/TechnicalGuruji">
              Tech Talks #1466 - BGMI 18 June Official, CoWIN Hacked?, Realme
              Laptop launch, Mi 11 Lite India, M32
            </a>
          }
          timestamp="1 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngAg8C9ez6SdBMdgEA-Aud61obXOuY1zsUPkL8Z0w=s176-c-k-c0x00ffffff-no-rj-mo"
          views="8M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCOhHO2ICt0ti9KAh-QHvttQ">
              TECHNICAL GURUJI
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/MLdXYEWTC1k/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLBKX7XaIqD2SFx5RL8Tu5d7M3QAaQ"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              Bahut Pighle Hain | Zakir khan | Stand-Up Comedy | Sukha poori 6
            </a>
          }
          timestamp="2 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwnjrRv8PYYcFcNXq2mB3ufVNSOF5N5Z2FV1ljxLhqA=s176-c-k-c0x00ffffff-no-rj-mo"
          views="1.4M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCkS7Vxu4PjM99w0Is6idjcg">
              ZAKIR KHAN
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/sZJd4epkDu4/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLDuPZmAXGoRijmfPPedlSYb1Gs59A"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              POCO M3 PRO 5G UNBOXING
            </a>
          }
          timestamp="7 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngJZm17vNotc0ojgs5rPQ7MC0eI7a2WsOtjw4SzLA=s68-c-k-c0x00ffffff-no-rj"
          views="5.8M Views"
          channel={
            <a href="https://www.youtube.com/c/TechBurner">TECH BURNER</a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/wGKb3oUo8go/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLDrOHgqSLiVBb9tFpSaTob6r2QRcA"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              WHY iphone's features always "LATE
            </a>
          }
          timestamp="9 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngW9TQgw7E7NqS3Qzd3Up3tjUzkpvMXPWAhYf3LaQ=s68-c-k-c0x00ffffff-no-rj"
          views="2.4M Views"
          channel={
            <a href="https://www.youtube.com/c/mkbhd">MARQUES BROWNLEE</a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/vqyIYTVFNck/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAT0MueYJBahmiM9FMn88MGWKOlGA"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              FARAAR|Latest Punjabi Song
            </a>
          }
          timestamp="4 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwnh5kAOkyTTcyFahoJLRRBSSdqYuZ-jDRt5MF2uqAA=s68-c-k-c0x00ffffff-no-rj"
          views="5M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCsaXTlOmt0o9aGeC_n_r8VQ">
              RUN UP RECORDS
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/BNnVy1pbF5w/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDHwNRoV85KGc-m1Yi20UFa1wVSTg"
          title={
            <a href="https://www.youtube.com/c/TechnicalGuruji">
              Tech Talks #1466 - BGMI 18 June Official, CoWIN Hacked?, Realme
              Laptop launch, Mi 11 Lite India, M32
            </a>
          }
          timestamp="1 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngAg8C9ez6SdBMdgEA-Aud61obXOuY1zsUPkL8Z0w=s176-c-k-c0x00ffffff-no-rj-mo"
          views="8M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCOhHO2ICt0ti9KAh-QHvttQ">
              TECHNICAL GURUJI
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/MLdXYEWTC1k/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLBKX7XaIqD2SFx5RL8Tu5d7M3QAaQ"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              Bahut Pighle Hain | Zakir khan | Stand-Up Comedy | Sukha poori 6
            </a>
          }
          timestamp="2 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwnjrRv8PYYcFcNXq2mB3ufVNSOF5N5Z2FV1ljxLhqA=s176-c-k-c0x00ffffff-no-rj-mo"
          views="1.4M Views"
          channel={
            <a href="https://www.youtube.com/channel/UCkS7Vxu4PjM99w0Is6idjcg">
              ZAKIR KHAN
            </a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/sZJd4epkDu4/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLDuPZmAXGoRijmfPPedlSYb1Gs59A"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              POCO M3 PRO 5G UNBOXING
            </a>
          }
          timestamp="7 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngJZm17vNotc0ojgs5rPQ7MC0eI7a2WsOtjw4SzLA=s68-c-k-c0x00ffffff-no-rj"
          views="5.8M Views"
          channel={
            <a href="https://www.youtube.com/c/TechBurner">TECH BURNER</a>
          }
        />
        <VideoCard
          image="https://i.ytimg.com/vi/wGKb3oUo8go/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&amp;rs=AOn4CLDrOHgqSLiVBb9tFpSaTob6r2QRcA"
          title={
            <a href="https://www.youtube.com/watch?v=vqyIYTVFNck">
              WHY iphone's features always "LATE
            </a>
          }
          timestamp="9 day ago"
          channelImage="https://yt3.ggpht.com/ytc/AAUvwngW9TQgw7E7NqS3Qzd3Up3tjUzkpvMXPWAhYf3LaQ=s68-c-k-c0x00ffffff-no-rj"
          views="2.4M Views"
          channel={
            <a href="https://www.youtube.com/c/mkbhd">MARQUES BROWNLEE</a>
          }
        />
        

       
      </div>
    </div>
  );
}

export default Recommended;
